import { render, staticRenderFns } from "./Comparison.vue?vue&type=template&id=25fcf059&scoped=true&"
import script from "./Comparison.vue?vue&type=script&lang=js&"
export * from "./Comparison.vue?vue&type=script&lang=js&"
import style0 from "./Comparison.vue?vue&type=style&index=0&id=25fcf059&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fcf059",
  null
  
)

export default component.exports